export const HuiRoutes = [
    {
        "url": "/hui",
        "name": "appLayout.harriSH.hui",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "abstract": true,
        "params": {},
        "component": "huiComponentsContainer",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hui"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hui/hui.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/:category",
        "name": "appLayout.harriSH.hui.category",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "views": {
            'hui-section': {
                'component': 'huiSectionsContainer'
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hui"]
        },
        "route_dependencies": []
    },
];
//# sourceMappingURL=hui.routes.js.map